export enum FeatureToggle {
  customersAndOrdersOrderDetailView = 'rt_cx_admin_migration_order_detail',
}
